import { z } from 'zod';
import { IsoDateTime, Uuid } from '../schemas/common.js';
import { NfcUid } from '../schemas/nfc-cards.js';
/**
 * Kiosk request bodies of the keyed NFC scheme (ADR 0024, 24 Oct 2026). They replace `NfcEnrolTap` in schemas/nfc-cards.ts.
 * Owner: architect.
 */
/** Site key (nfcSiteKey) as the kiosk sends it. */
export const NfcSiteKeyHex = z.string().regex(/^[0-9a-f]{64}$/);
/**
 * Kiosk -> POST /nfc-cards/device/enrolments/:id/cards. The one place a kiosk sends a UID: online, over TLS, during an
 * admin's enrolment session, so the server can key it with the tenant secret. The kiosk keeps it in memory only.
 */
export const NfcEnrolCardTap = z.object({ memberId: Uuid, uid: NfcUid });
/** Kiosk -> POST /nfc-cards/device/blocked-use: the site key of a card the kiosk refused itself. */
export const NfcBlockedUse = z.object({ uidKey: NfcSiteKeyHex, occurredAt: IsoDateTime });
//# sourceMappingURL=wire.js.map